import PhotoProfilePanel from "./photoProfilePanel.container";

export default PhotoProfilePanel;
